<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-3xl mx-4 sm:mx-6">
  @if (contact) {
  <div class="p-6 sm:p-8">
    <!-- Header with Avatar -->
    <div class="flex items-start gap-6 mb-8">
      <!-- Avatar Circle with Initials -->
      <div class="flex-shrink-0">
        <div class="flex h-20 w-20 items-center justify-center rounded-full {{ avatarColorClass }}">
          <span class="text-2xl font-semibold">{{ initials }}</span>
        </div>
      </div>

      <!-- Name and Title -->
      <div class="flex-1 min-w-0">
        <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-1">
          {{ fullName }}
        </h2>
        @if (contact.position) {
        <p class="text-base text-gray-600 dark:text-gray-400">
          {{ contact.position }}
        </p>
        }
      </div>

      <!-- responsable + quick actions -->
      <div class="mt-auto pt-4 flex flex-col items-end gap-2">
        <app-quick-actions-menu
          label="Acciones"
          align="right"
          [contactId]="contact.id"
          [contactName]="(contact.fullname || '') + (contact.lastname ? ' ' + contact.lastname : '')"
          [contactEmail]="contact.mail"
          [contactPhone]="contact.phone"
          (actionTriggered)="onClose()">
        </app-quick-actions-menu>
        <div class="flex items-center gap-2 justify-end">
          <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Responsable:</span>
          @if (loadingUsers) {
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
          } @else if (ownerUser) {
            <span class="text-sm font-medium text-gray-900 dark:text-white">
              {{ ownerLabel }}
            </span>
          } @else {
            <span class="text-sm text-gray-400 dark:text-gray-500">{{ ownerLabel }}</span>
          }
        </div>
      </div>

    </div>

    <!-- Tab navigation -->
    <div class="border-b border-gray-200 dark:border-gray-700 mb-6">
      <nav class="-mb-px flex gap-1">
        <button
          (click)="onTabChange('info')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'info'"
          [class.text-brand-600]="activeTab === 'info'"
          [class.dark:text-brand-400]="activeTab === 'info'"
          [class.border-transparent]="activeTab !== 'info'"
          [class.text-gray-500]="activeTab !== 'info'"
          [class.hover:text-gray-700]="activeTab !== 'info'"
          [class.dark:text-gray-400]="activeTab !== 'info'">
          Información
        </button>
        <button
          (click)="onTabChange('timeline')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'timeline'"
          [class.text-brand-600]="activeTab === 'timeline'"
          [class.dark:text-brand-400]="activeTab === 'timeline'"
          [class.border-transparent]="activeTab !== 'timeline'"
          [class.text-gray-500]="activeTab !== 'timeline'"
          [class.hover:text-gray-700]="activeTab !== 'timeline'"
          [class.dark:text-gray-400]="activeTab !== 'timeline'">
          Línea de Tiempo
        </button>
        <button
          (click)="onTabChange('correos')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'correos'"
          [class.text-brand-600]="activeTab === 'correos'"
          [class.dark:text-brand-400]="activeTab === 'correos'"
          [class.border-transparent]="activeTab !== 'correos'"
          [class.text-gray-500]="activeTab !== 'correos'"
          [class.hover:text-gray-700]="activeTab !== 'correos'"
          [class.dark:text-gray-400]="activeTab !== 'correos'">
          Correos
        </button>
        <button
          (click)="onTabChange('automatizaciones')"
          class="whitespace-nowrap px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
          [class.border-brand-500]="activeTab === 'automatizaciones'"
          [class.text-brand-600]="activeTab === 'automatizaciones'"
          [class.dark:text-brand-400]="activeTab === 'automatizaciones'"
          [class.border-transparent]="activeTab !== 'automatizaciones'"
          [class.text-gray-500]="activeTab !== 'automatizaciones'"
          [class.hover:text-gray-700]="activeTab !== 'automatizaciones'"
          [class.dark:text-gray-400]="activeTab !== 'automatizaciones'">
          Automatizaciones
        </button>
      </nav>
    </div>

    <!-- ========== TAB: INFO ========== -->
    @if (activeTab === 'info') {
    <div class="space-y-6">
      <!-- Contact Details Section -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
          Información de Contacto
        </h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Email -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Email</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white break-all">
                {{ contact.mail }}
              </p>
            </div>
          </div>

          <!-- Phone -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Teléfono</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ contact.phone || '—' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Lead Information Section -->
      <div>
        <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
          Información del Lead
        </h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Contact State -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ getContactStateName() }}
              </p>
            </div>
          </div>

          <!-- Contact Cycle -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Ciclo de Contacto</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ getCycleName() }}
              </p>
            </div>
          </div>

          <!-- Origin -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                </path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Origen</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ getOriginName() }}
              </p>
            </div>
          </div>

          <!-- Score -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Score</p>
              <div class="flex items-center gap-2 mt-0.5">
                <div class="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" style="max-width: 80px;">
                  <div class="h-full rounded-full transition-all"
                    [style.width.%]="contact.score ?? 0"
                    [class]="(contact.score ?? 0) >= 70 ? 'bg-success-500'
                           : (contact.score ?? 0) >= 40 ? 'bg-warning-500'
                           : 'bg-gray-400'">
                  </div>
                </div>
                <span class="text-sm font-semibold"
                  [class]="(contact.score ?? 0) >= 70 ? 'text-success-600 dark:text-success-400'
                         : (contact.score ?? 0) >= 40 ? 'text-warning-600 dark:text-warning-400'
                         : 'text-gray-600 dark:text-gray-300'">
                  {{ contact.score ?? 0 }}/100
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empresas Section -->
      <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
        <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
          Empresas
        </h3>

        <!-- Loading -->
        @if (loadingCompanies) {
          <div class="flex items-center gap-3 py-4">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
            <span class="text-sm text-gray-500 dark:text-gray-400">Cargando empresas...</span>
          </div>
        }

        <!-- Error -->
        @if (companiesError) {
          <div class="flex items-center gap-2 py-3 text-sm text-red-600 dark:text-red-400">
            {{ companiesError }}
          </div>
        }

        <!-- Empty -->
        @if (!loadingCompanies && !companiesError && companies.length === 0) {
          <div class="text-center py-6 text-gray-400 dark:text-gray-500">
            <svg class="w-8 h-8 mx-auto mb-2 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
            </svg>
            <p class="text-sm">No hay empresas asociadas a este contacto.</p>
          </div>
        }

        <!-- List -->
        @if (!loadingCompanies && companies.length > 0) {
          <div class="space-y-3">
            @for (assoc of companies; track assoc.id) {
              <div class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50">
                <div class="flex-shrink-0 flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold {{ getCompanyAvatarColor(assoc) }}">
                  {{ getCompanyInitials(assoc) }}
                </div>
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-2 flex-wrap">
                    <span class="text-sm font-medium text-gray-900 dark:text-white">
                      {{ assoc.company?.commercialName }}
                    </span>
                    @if (assoc.isPrimary) {
                      <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-brand-50 text-brand-700 dark:bg-brand-900 dark:text-brand-300">
                        <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                        </svg>
                        Principal
                      </span>
                    }
                  </div>
                  <div class="flex items-center gap-3 mt-0.5 flex-wrap">
                    @if (assoc.position) {
                      <span class="text-xs text-gray-500 dark:text-gray-400 italic">{{ assoc.position }}</span>
                    }
                    @if (assoc.company?.phone) {
                      <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
                      <span class="text-xs text-gray-500 dark:text-gray-400">{{ assoc.company?.phone }}</span>
                    }
                    @if (assoc.company?.website) {
                      <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
                      <span class="text-xs text-gray-500 dark:text-gray-400">{{ assoc.company?.website }}</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Custom Attributes Section -->
      <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
        <h3 class="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-3">
          Atributos Personalizados
        </h3>

        @if (loadingCustomAttributes) {
          <div class="flex items-center gap-3 py-4">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
            <span class="text-sm text-gray-500 dark:text-gray-400">Cargando atributos...</span>
          </div>
        }

        @if (!loadingCustomAttributes && customAttributes.length === 0) {
          <p class="text-sm text-gray-400 dark:text-gray-500 py-2">Sin atributos personalizados.</p>
        }

        @if (!loadingCustomAttributes && customAttributes.length > 0) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            @for (attr of customAttributes; track attr.id) {
              <div class="flex items-start gap-3">
                <!-- Icon by type -->
                <div class="flex-shrink-0 mt-0.5">
                  @if (attr.type === 'boolean') {
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                    </svg>
                  }
                  @if (attr.type === 'number') {
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/>
                    </svg>
                  }
                  @if (attr.type === 'list') {
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
                    </svg>
                  }
                  @if (attr.type === 'text' || !attr.type) {
                    <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                    </svg>
                  }
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-xs text-gray-500 dark:text-gray-400">{{ attr.definitionName }}</p>
                  @if (attr.type === 'boolean') {
                    <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium mt-0.5"
                      [class]="attr.bolValue
                        ? 'bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-400'
                        : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'">
                      {{ attr.bolValue ? 'Sí' : 'No' }}
                    </span>
                  }
                  @if (attr.type !== 'boolean') {
                    <p class="text-sm font-medium text-gray-900 dark:text-white mt-0.5">
                      {{ getCustomAttributeDisplayValue(attr) }}
                    </p>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>

      <!-- Timestamps Section -->
      <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <!-- Created Date -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Fecha de Creación</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ formatDate(contact.datetimeCreate) }}
              </p>
            </div>
          </div>

          <!-- Creado por -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Creado por</p>
              @if (loadingUsers) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500 mt-1"></div>
              } @else {
                <p class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ createdByLabel }}
                </p>
              }
            </div>
          </div>

          <!-- Updated Date -->
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0 mt-0.5">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                </path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Última Actualización</p>
              <p class="text-sm font-medium text-gray-900 dark:text-white">
                {{ formatDate(contact.datetimeUpdate) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    } <!-- end info tab -->

    <!-- ========== TAB: TIMELINE ========== -->
    @if (activeTab === 'timeline') {
      <app-audit-timeline
        [logs]="timelineLogs"
        [loading]="loadingTimeline"
        [error]="timelineError"
        [currentPage]="timelinePage"
        [totalPages]="timelineTotalPages"
        [totalElements]="timelineTotalElements"
        emptyMessage="No hay eventos de auditoría para este contacto."
        (pageChange)="loadTimeline($event)" />
    } <!-- end timeline tab -->

    <!-- ========== TAB: CORREOS ========== -->
    @if (activeTab === 'correos') {
      <app-contacto-correos
        [contactId]="contact.id ?? null"
        [active]="activeTab === 'correos'" />
    } <!-- end correos tab -->

    <!-- ========== TAB: AUTOMATIZACIONES ========== -->
    @if (activeTab === 'automatizaciones' && contact.id) {
      <app-workflow-record-history
        objectType="CONTACT"
        [objectId]="contact.id" />
    } <!-- end automatizaciones tab -->

  </div>
  }
</app-modal>
